import type { ClassValue } from 'clsx';

import type { ProductLabel, StockInfo } from '../../../../product/index';
import { Separator } from '@vs-shop/ui/separator';
import { clsxm } from '@vs-shop/utils';
import { Option } from 'effect';

import {
  ProductCardPriceRow,
  ProductCardVariant,
  type ProductCardVariant as ProductCardVariantName,
} from '@vs-shop/commerce-ui/productCard';

import { ProductCardPrice } from './ProductCardPrice';
import ProductCardStockAndFreeShipping from './ProductCardStockAndFreeShipping';

type Props = {
  /** `None` when the variant carries no channel price — never fabricated as `0`. */
  price: Option.Option<number>;
  /** Raw `number | null` until `ProductCardData` ships branded money (ledger debt). */
  originalPrice: number | null;
  stock: StockInfo;
  labels: readonly ProductLabel[];
  variant: ProductCardVariantName;
  className?: ClassValue;
};

/**
 * Price and availability, bound to rcprofi's product data.
 *
 * The compact appearance rules a line between the two — an rcprofi arrangement
 * rather than section anatomy, so it stays a composed `Separator` here.
 */
export default function ProductCardPriceStock({
  price,
  originalPrice,
  stock,
  labels,
  variant,
  className,
}: Props) {
  return (
    <ProductCardPriceRow variant={variant} className={clsxm(className)}>
      {Option.match(price, {
        onNone: () => null,
        onSome: (value) => (
          <ProductCardPrice price={value} originalPrice={originalPrice} variant={variant} />
        ),
      })}

      {variant === ProductCardVariant.MINIMALIST ? (
        <Separator className="mx-auto my-2 w-6" />
      ) : null}

      <ProductCardStockAndFreeShipping stock={stock} labels={labels} variant={variant} />
    </ProductCardPriceRow>
  );
}
